<ui-filter-container
    [dynamicColumns]="true"
    (toggledFilters)="toggledFilters.emit($event)"
>
    <ui-text-filter
        search-filter
        [filter]="searchFilter"
        [placeholder]="'Suchbegriff eingeben'"
    />

    <ui-multi-select-filter
        [filter]="categoriesFilter"
        [options]="(categoriesOptions$ | async) ?? filterOptionsFallback"
        [placeholder]="(categoriesFilterPlaceholder$ | async) ?? ''"
        (reloadFilterOptions)="reloadFilterOptions()"
    />

    <ui-multi-select-filter
        [filter]="sponsorsFilter"
        [options]="(sponsorsOptions$ | async) ?? filterOptionsFallback"
        [placeholder]="(sponsorsFilterPlaceholder$ | async) ?? ''"
        (reloadFilterOptions)="reloadFilterOptions()"
    />
</ui-filter-container>
